import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTextboxMultiple = () => {
  return (
    <g>
      <path d="M15.3 9a.7.7 0 0 1 .694.605L16 9.7v4.6a.7.7 0 0 1-.605.694L15.3 15H.7a.7.7 0 0 1-.694-.605L0 14.3V9.7a.7.7 0 0 1 .605-.694L.7 9h14.6zm-.85 1.55H1.55v2.9h12.9v-2.9zM15.3 1a.7.7 0 0 1 .694.605L16 1.7v4.6a.7.7 0 0 1-.605.694L15.3 7H.7a.7.7 0 0 1-.694-.605L0 6.3V1.7a.7.7 0 0 1 .605-.694L.7 1h14.6zm-.85 1.55H1.55v2.9h12.9v-2.9z" />
    </g>
  );
};

export default withIcon(IconTextboxMultiple);
